import type { TesseractStaffEntry } from '../services/tesseractStaffApi';

function compactUuid(uuid: string): string {
  return uuid.replace(/-/g, '').toLowerCase();
}

/**
 * Case-insensitive match on UUID (with or without hyphens) and on resolved username.
 * Call after usernames for `staff` entries are available in the cache when matching by name.
 */
export function filterStaffByQuery(
  staff: TesseractStaffEntry[],
  query: string,
  usernameLookup: (uuid: string) => string | null
): TesseractStaffEntry[] {
  const q = query.trim().toLowerCase();
  if (!q) return [...staff];

  const qCompact = compactUuid(q);

  return staff.filter((s) => {
    const uuid = s.minecraft_uuid;
    const uuidLower = uuid.toLowerCase();
    if (uuidLower.includes(q)) return true;
    if (qCompact.length >= 4 && compactUuid(uuid).includes(qCompact)) return true;
    const name = usernameLookup(uuid);
    if (name && name.toLowerCase().includes(q)) return true;
    return false;
  });
}
